// helpers/intervalAndFamilies.js

import { normRat, ratToLatexPi, uniqueRats, ratEq } from "./piRats";

/* =========================
   Intervals (as multiples of pi)
   ========================= */
export function intervalLatex(interval) {
  return `\\left[${ratToLatexPi(interval.start)}\\,,\\,${ratToLatexPi(
    interval.end
  )}\\right]`;
}

export function intervalText(interval) {
  // human-ish
  const a = ratToLatexPi(interval.start)
    .replaceAll("\\dfrac", "")
    .replaceAll("{", "")
    .replaceAll("}", "");
  const b = ratToLatexPi(interval.end)
    .replaceAll("\\dfrac", "")
    .replaceAll("{", "")
    .replaceAll("}", "");
  return `[${a}, ${b}]`;
}

export function getIntervalBounds(interval) {
  const a = (interval.start.num / interval.start.den) * Math.PI;
  const b = (interval.end.num / interval.end.den) * Math.PI;
  return { a, b };
}

export function inInterval(x, a, b) {
  return x >= a - 1e-12 && x <= b + 1e-12;
}

/* =========================
   Families -> solutions in interval
   family: x = a + k*b where a,b are rationals (multiples of pi)
   ========================= */
export function solutionsFromFamilies(families, interval) {
  const { a, b } = getIntervalBounds(interval);
  const sols = [];

  const pushRat = (r) => {
    if (!r) return;
    const x = (r.num / r.den) * Math.PI;
    if (inInterval(x, a, b)) sols.push(r);
  };

  for (const fam of families) {
    const aN = fam.a.num;
    const aD = fam.a.den;
    const bN = fam.b.num;
    const bD = fam.b.den;

    for (let k = -120; k <= 120; k += 1) {
      // (a_num/a_den) + k*(b_num/b_den) = (a_num*b_den + k*b_num*a_den)/(a_den*b_den)
      const num = aN * bD + k * bN * aD;
      const den = aD * bD;
      pushRat(normRat(num, den));
    }
  }

  return uniqueRats(sols).sort((p, q) => p.num / p.den - q.num / q.den);
}
